import { LoggingConfig } from 'src/@ccmc/logging/models';

export const environment = {
  production: true,
  test: false,
  dev: false,
  environmentURL: "aHR0cHM6Ly9hcGkubnh0c29mdC5jb20vdjE=",
  packageVERSION: "Mi4xMS4w",
  
  /**
   * Logging configuration for production environment
   * 
   * Optimized for performance and minimal overhead:
   * - Console output DISABLED (no logs in browser console)
   * - Larger batch sizes (50) for efficiency
   * - Less frequent flushes (10 seconds)
   * - Smaller queue size (500) to reduce memory usage
   * - CloudWatch logging to 'ground-control-prod' log group
   * - Smaller auth failure queue (50) to reduce memory usage
   * - Longer auth retry interval (60 seconds) to reduce API calls
   * - Auth error suppression enabled for smooth logout
   * 
   * Features disabled:
   * - Debug logging
   * - Metrics reporting
   * - Console output
   */
  logging: {
    enableConsoleOutput: false,
    logGroup: 'ground-control-prod',
    enableDebugLogging: false,
    enableMetricsReporting: false,
    enableCloudWatchOnStartup: true,
    batchSize: 50,
    flushIntervalMs: 10000,
    maxRetries: 3,
    maxQueueSize: 500,
    authFailureQueueSize: 50,
    authRetryIntervalMs: 60000,
    suppressAuthErrorsOnLogout: true
  } as LoggingConfig
}
